<nav
  class="top-navbar"
  [class.top-navbar--hidden]="!isVisible"
  [class.top-navbar--compact]="isCompact"
  [class.top-navbar--limeapp-offset]="applyOffset"
>
  <button
    class="top-navbar__back-btn"
    data-testid="qa-top-navbar-back-btn"
    [attr.aria-label]="'aria.go-back' | translate"
    (click)="goBack()"
  >
    <i class="navbar__back-icon" [class]="backIcon"></i>
  </button>
  <span class="top-navbar__title">{{ title | translate }}</span>
</nav>
